<template>
  <div id="app">
    <img width="25%">
    <!-- <HelloWorld/> -->
	<div  ref="hello">
		<h4 style="opacity: 0;">gsgsgsgsgsgsgsggs</h4>
		<h4>gsgsgsgsgsgsgsggs</h4>
	</div>
    <img :src="output">
  </div>
</template>

<script>
// import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",
  components: {
    // HelloWorld
  },
  data: () => ({
    output: ""
  }),
  async mounted() {
	let el = this.$refs.hello;
	// console.log('el',el);
	//  el.removeChild('idid');
	// console.log('2222222222222222222222 el', el);
    let options = { type: "dataURL" };
	this.output = await this.$html2canvas(el, options);
	// console.log('22222222222222',this.output);
  }
};
</script>

<style>
/* #app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
